module.exports = __webpack_public_path__ + "img/skin-tight.d012005d.png";